import { render, staticRenderFns } from "./VAdministrationSectionsTable.vue?vue&type=template&id=1ca28374&"
import script from "./VAdministrationSectionsTable.vue?vue&type=script&lang=ts&"
export * from "./VAdministrationSectionsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports